import getAccessibleProducts from './getAccessibleProducts';

const getAccessibleProductNames = config => getAccessibleProducts(config).map(arr => arr[0]);

export default getAccessibleProductNames;
//# sourceMappingURL=getAccessibleProductNames.js.map